import React from 'react'
import styled from 'styled-components'
import { graphql,useStaticQuery } from 'gatsby'
import { Link } from 'gatsby' 
import { uniq } from "lodash"
import { cloneWith } from 'lodash'
const NavbarWrapper = styled.div`
position: relative;
    background: #FFFFFF;
    box-shadow: 0px 30px 100px rgb(0 0 0 / 8%);
    width: 100%;
    border-radius: 8px;
    display: -webkit-box;
    display: -webkit-flex;
    justify-content: center;
    display: -ms-flexbox;
    display: flex;
    margin-top: 2rem;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    gap: 93.33px;
  
   
    
`
const Flex = styled.div`
    display: flex;
    width: 100%;
    flex-direction:row;
    flex-wrap:wrap;
    gap: 5rem;
    justify-content: start;
    padding: 74px 103px;
    @media  screen and (max-width:980px)
    {
        display:grid;
    }
`
const Navbar = styled.div`
  flex: 1;
  display:flex;
  flex-direction: column;
  width: -webkit-fill-available;

`
const NavTitle = styled.h1`
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;

  letter-spacing: -1px;
  position:relative;
  color: #000000;
  margin-bottom: 1.5rem;
  &::after{
    content: '';
    position: absolute;
    height: 1.5px;
    width:100%;
    right: 0;
    background: rgba(0,0,0,0.05);
    top: 150%;
  }
`
const NavbarFlex  = styled.ul`
display:flex;
flex-direction: column;
gap:20px;
list-style: none;
    padding: 0;
`
const NavLink = styled.li`

`
function NavbarMenu() {
  const {allPrismicCollection} = useStaticQuery(graphql`
  query {
    allPrismicCollection {
      nodes {
        data {
          collection {
            text
          }
          tags {
            tag
          }
        }
      }
    }
  }
`)
const Duplication = (arg) =>
{
  var newArray = Array.prototype.concat.apply([], arg);
 
 console.log(newArray)
}
function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
  return (
    <NavbarWrapper >

    <Flex >
      {allPrismicCollection.nodes.map((collection)=>
      (
        <Navbar>
        <NavTitle>{collection.data.collection.text}</NavTitle>
        <NavbarFlex>
        {collection.data.tags.map((tag)=>
             <NavLink><Link to='#'>{tag.tag}</Link></NavLink>
        )}

        </NavbarFlex>
      </Navbar>
     
      )
      )}
         
   
    </Flex>
   </NavbarWrapper>
    
  )
}

export default NavbarMenu